export default function initContactForm() {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    const selectedTopic = getQueryParam('category');

    setTimeout(function () {
        document.querySelectorAll('.support-form .dccs-form-fields').forEach($container => {
            const $filterType = $container.querySelectorAll('.filter');
            const $requestType = $container.querySelectorAll('#WebRequestType__c')[0];
            const $category = $container.querySelectorAll('.category select');
            const $filterDivs = $container.querySelectorAll(':scope > div');
            const $categoryDivs = $container.querySelectorAll('.main-category > div');
            const $submitContainer = $container.querySelectorAll('.dccs-form-actions');
            const $forHiding = $container.querySelectorAll('.to-hide');
            const $forShowing = $container.querySelectorAll('.to-show');
            const allowedTypes = ['semi-context'];
            const $thirdPartyCheck = $container.querySelectorAll('.thirdPartyCheckbox');
            $forHiding.forEach($div => {
                $div.classList.add('is-hidden');
                $div.classList.remove('to-hide');
                $div.querySelectorAll('input, select').forEach($input => {
                    $input.classList.add('no-validate');
                    $input.value = null;
                });
            });
            $forShowing.forEach($div => {
                if ($div.classList.contains('is-hidden')) {
                    $div.classList.remove('is-hidden');
                    $div.classList.remove('to-show');
                    $div.querySelectorAll('input, select').forEach($input => {
                        $input.classList.add('normal-validate');
                    });
                }
            });

            $filterType.forEach($filter =>
                $filter.addEventListener('change', () => {
                    const $filterValue = $filter.querySelectorAll('select')[0].value;
                    $filterDivs.forEach($div => {
                        if ($div.classList.contains('filter-result')) {
                            if ($div.classList.contains($filterValue)) {
                                $div.classList.remove('is-hidden');
                            } else if (!$div.classList.contains('is-hidden')) {
                                $div.classList.add('is-hidden');
                            }
                        }
                    });
                    if (allowedTypes.includes($filterValue)) {
                        $submitContainer[0].classList.remove('is-hidden');
                    } else {
                        $submitContainer[0].classList.add('is-hidden');
                    }
                })
            );

            if ($thirdPartyCheck) {
                const $thirdPartyDiv = document.querySelectorAll('.thirdPartyCheck');
                $thirdPartyDiv.forEach($div => {
                    $div.querySelectorAll('input, select').forEach($input => {
                        if ($input.classList.contains('normal-validate')) {
                            $input.classList.remove('normal-validate');
                        }
                        $input.classList.add('no-validate');
                        $input.value = null;
                    });
                });
                $thirdPartyCheck.forEach($checkbox =>
                    $checkbox.addEventListener('change', () => {
                        if ($checkbox.getAttribute('value') === 'true') {
                            //open 3rd party requestor section
                            document.querySelector('.thirdPartyCheck').classList.remove('is-hidden');

                            $thirdPartyDiv.forEach($div => {
                                $div.querySelectorAll('input, select').forEach($input => {
                                    if ($input.classList.contains('no-validate')) {
                                        $input.classList.remove('no-validate');
                                    }
                                    $input.classList.add('normal-validate');
                                    $input.value = null;
                                });
                            });
                        } else {
                            // hide 3rd party requestor section
                            document.querySelector('.thirdPartyCheck').classList.add('is-hidden');
                            $thirdPartyDiv.forEach($div => {
                                $div.querySelectorAll('input, select').forEach($input => {
                                    if ($input.classList.contains('normal-validate')) {
                                        $input.classList.remove('normal-validate');
                                    }
                                    $input.classList.add('no-validate');
                                    $input.value = null;
                                });
                            });
                        }
                    })
                );
            }

            var resetButton = document.getElementById('resetFileId');
            if (resetButton !== null) {
                resetButton.addEventListener('click', () => {
                    document.getElementById('displayFileSection').classList.add('is-hidden');
                    document.querySelector('input[type=file]').value = '';
                    document.getElementById('resetAttach').value = 'true';
                    document.dispatchEvent(new Event('ams-osram:form:reset-files'));
                });
            }

            if ($category) {
                $category.forEach($select =>
                    $select.addEventListener('change', () => {
                        $categoryDivs.forEach($div => {
                            if ($div.classList.contains('subcategory')) {
                                if (
                                    !$div.classList.contains('is-hidden') &&
                                    !$div.classList.contains('category') &&
                                    !(
                                        $div.classList.contains('subcategory') &&
                                        $div.classList.contains('document-feedback') &&
                                        $requestType.value == 'document-feedback'
                                    )
                                ) {
                                    $div.classList.add('is-hidden');
                                    $div.querySelectorAll('input, select').forEach($input => {
                                        if ($input.classList.contains('normal-validate')) {
                                            $input.classList.remove('normal-validate');
                                        }
                                        $input.classList.add('no-validate');
                                        $input.value = null;
                                    });
                                }

                                if ($div.classList.contains($select.value.toLowerCase())) {
                                    $div.classList.remove('is-hidden');
                                    $div.querySelectorAll('input, select').forEach($input => {
                                        $input.value = null;
                                        if ($input.classList.contains('no-validate')) {
                                            $input.classList.remove('no-validate');
                                        }
                                        $input.classList.add('normal-validate');
                                    });
                                }
                            }
                        });
                    })
                );
                if (selectedTopic) {
                    $category[0].value = selectedTopic;
                    $category[0].dispatchEvent(new Event('change'));
                }
            }

            const $parentContainer =
                $container.parentNode !== null &&
                $container.parentNode !== undefined &&
                $container.parentNode.parentNode !== null &&
                $container.parentNode.parentNode !== undefined &&
                $container.parentNode.parentNode.parentNode !== null &&
                $container.parentNode.parentNode.parentNode !== undefined
                    ? $container.parentNode.parentNode.parentNode
                    : null;

            const $loadingInfo = $parentContainer.parentNode.querySelector('.form-is-loading');

            if ($parentContainer.classList.contains('is-hidden')) {
                $parentContainer.classList.remove('is-hidden');
                $loadingInfo.remove();
                if ($parentContainer.dataset.scrollTo) {
                    const $scrollToContainers = $parentContainer.querySelectorAll(
                        'div.' + $parentContainer.dataset.scrollTo
                    );
                    let $scrollToContainer = null;

                    if ($scrollToContainers.length > 0) {
                        $scrollToContainer = $scrollToContainers[0];

                        window.scrollTo({
                            top: window.pageYOffset + $scrollToContainer.getBoundingClientRect().top - 16,
                            behavior: 'smooth',
                        });
                    }
                }
            }
        });
    }, 1500);
}
